import { toast, Bounce } from "react-toastify";

/*
Function to check if a given request has error code for authentication failed and show message
Returns:
    True: if authentication error found
    False: otherwise
*/
export function checkForAuthenticationError(request) {
  let errorCodes = [400, 401];
  if (request && request.data && errorCodes.includes(request.data.code)) {
    try {
      const message = request.data.error;
      toast(message, {
        transition: Bounce,
        closeButton: true,
        autoClose: 5000,
        position: "top-right",
        type: "error",
      });
      return true;
    } catch (error) {
      return false;
    }
  } else {
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/utils/functions.js